import { useEffect, useRef, useState } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fromEvent } from "rxjs";
import { debounceTime, switchMap } from "rxjs/operators";
import { ContratLocation } from "../../models/models";
import { RootState, AppDispatch } from "../../reduxStore/Store";
import { AutocompleteProps } from "@mui/material/Autocomplete";

import {
    fetchContratLocationByFilters,
  clearContratLocationData
} from "../../reduxStore/contratLocationSlice"; // Make sure it's exported
import { labels } from "../../constants/labels";
interface ContratAutoCProps
extends Partial<AutocompleteProps<ContratLocation, false, false, false>>  {
  onContratChange: (contrat: ContratLocation | null) => void;
  selectedContrat?: ContratLocation | null;
}

const limit = 10;
const offset = 0;

const ContratAutoC: React.FC<ContratAutoCProps> = ({ onContratChange, selectedContrat,...autocompleteProps }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { contratLocationData, loading } = useSelector((state: RootState) => state.ContratLocationSlice);
  const [contrat, setContrat] = useState<ContratLocation | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (selectedContrat) {
      setContrat(selectedContrat);
    }
  }, [selectedContrat]);

  useEffect(() => {
    if (inputRef.current) {
      const subscription = fromEvent(inputRef.current, "input")
        .pipe(
          debounceTime(500),
          switchMap((event: any) => {
            const numero_contrat = event.target.value.trim();
            if (numero_contrat.length > 2) {
              dispatch(fetchContratLocationByFilters({ numero_contrat, limit, offset }));
            }
            return [];
          })
        )
        .subscribe();

      return () => subscription.unsubscribe();
    }
  }, [dispatch]);

  const handleChange = (_: any, newValue: ContratLocation | null) => {
    setContrat(newValue);
    onContratChange(newValue);
  };

  return (
    <Autocomplete
      options={contratLocationData}
      value={contrat}
      getOptionLabel={(option: ContratLocation) => option?.numero_contrat ?? ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      loading={loading}
      onChange={handleChange}
      onBlur={() => dispatch(clearContratLocationData())}
      {...autocompleteProps}
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={inputRef}
          label={labels.numeroContrat}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          size="small"
        />
      )}
    />
  );
};

export default ContratAutoC;
